import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-scroll";
// import moon from '../assets/Experience/moon.png'
// import sun from '../assets/Experience/sun.png'
import { navigation } from "./Constants";

const NavBar = () => {
  const [isMobileMenu, setIsMobileMenu] = useState(false);

  return (
    <div
      className={`fixed flex items-center justify-between w-full h-20 md:px-4 px-1  bg[#F4F4F6]  backdrop-blur-[12px] z-40 shadow-dark `}
    >
      {/* <div 
      className='hidden cursor-pointer themeController'
      onClick={toggleTheme}
      >
        
       {
         darkMode ? 
            <img src={moon} alt="moon" className=' themeIcon dissappear'  /> 
            :
            <img src={sun} alt="sun" className=' themeIcon appear' />
       }
      </div> */}
      <div>
        <h1 className="text-3xl ml-2 font-bold text-[#CCD6F6] sm:text-4xl">
          Firdosh
        </h1>
      </div>

      <ul className="hidden md:flex">
        {navigation.map(({ link, id }) => (
          <li
            key={id}
            className="px-4 font-medium text-gray-400 capitalize duration-200 cursor-pointer hover:scale-105"
          >
            <Link
              to={link}
              href={`#${link}`}
              smooth
              duration={500}
              offset={-50}
              spy={true}
              activeClass="before:scale-x-100 before:origin-left"
              className={`cursor-pointer transition duration-300 transform relative group
              before:content-[''] before:absolute before:bottom-0 before:left-0 before:h-[2px] before:w-full
            before:bg-[#9857D3] before:transform before:transition-transform before:duration-300 before:ease-out
              before:scale-x-0 group-hover:before:scale-x-100 group-hover:before:origin-left`}
            >
              {link}
            </Link>
          </li>
        ))}
      </ul>

      <div
        onClick={() => setIsMobileMenu((prev) => !prev)}
        className="z-[9999] pr-4 text-[#CCD6F6] cursor-pointer md:hidden"
      >
        {isMobileMenu ? <FaTimes size={30} /> : <FaBars size={30} />}
      </div>

      {isMobileMenu && (
        <ul className="absolute top-0 left-0 flex flex-col items-center justify-center w-full h-screen  text-[#b2bad5d3]  bg-[#11071f] ">
          {navigation.map(({ link, id }) => (
            <li
              key={id}
              className="px-4 py-6 text-4xl capitalize cursor-pointer"
            >
              <Link
                onClick={() => setIsMobileMenu((prev) => !prev)}
                to={link}
                smooth
                duration={500}
              >
                {link}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default NavBar;
